module.exports = {"hello":"Hello!","language":"Language"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en.json
// module id = 669
// module chunks = 1